import { render, staticRenderFns } from "./DispatchRequestSection.vue?vue&type=template&id=234906b5&scoped=true"
import script from "./DispatchRequestSection.vue?vue&type=script&lang=ts"
export * from "./DispatchRequestSection.vue?vue&type=script&lang=ts"
import style0 from "./DispatchRequestSection.vue?vue&type=style&index=0&id=234906b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234906b5",
  null
  
)

export default component.exports